import { TCopyConfig } from '../../../interfaces';
import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleSCCopy: DeepPartial<TCopyConfig> = {
  addVehicleAddons: [
    'towing_road_services',
    'loss_of_use',
    'ridesharing',
    'loan_lease_payoff',
    'oem_parts',
    'new_car_replacement',
  ],
  autoAddons: {
    oem_parts: {
      title: 'OEM Parts',
    },
  },
  autoAddonsOrder: [
    'towing_road_services',
    'loss_of_use',
    'ridesharing',
    'loan_lease_payoff',
    'oem_parts',
    'new_car_replacement',
  ],
  autoDiscounts: [
    AUTO_DISCOUNTS.aeb,
    AUTO_DISCOUNTS.continuousInsurance,
    AUTO_DISCOUNTS.defensiveDriver,
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.claimFree,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.accidentFree,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.teenDriver,
    AUTO_DISCOUNTS.threeYearSafeDriving,
  ],
  visibleCoverages: {
    protectionCoverages: [
      {
        label: 'Underinsured Motorist Bodily Injury',
        key: 'underinsured_motorist_bodily_injury_limit',
      },
    ],
  },
  vehicleAddons: [
    {
      label: 'Towing & Road Services',
      key: 'towing_road_services',
    },
    {
      label: 'Loss of Use',
      key: 'loss_of_use',
    },
    {
      label: 'Ridesharing',
      key: 'ridesharing',
    },
    {
      label: 'Residual Debt (loan payoff)',
      key: 'loan_lease_payoff',
    },
    {
      label: 'OEM Parts',
      key: 'oem_parts',
    },
    {
      label: 'New Car Replacement',
      key: 'new_car_replacement',
    },
  ],
  initialCoverageValues: {
    loan_lease_payoff: 'false',
    loss_of_use: 'null',
    ridesharing: 'false',
  },
};
export default ToggleSCCopy;
